import React from "react";
import { Button } from "convertupleads-theme";
import PreviewAndEditor from "../../../../../common/PreviewAndEditor";

const DefaultButtonLarge = () => {
  return (
    <>
      <PreviewAndEditor
        height={"100px"}
        language="js"
        title={"Contained Large button"}
        value={'<Button size={"large"}>Large</Button>'}
      >
        <Button size={"large"}>Large</Button>
      </PreviewAndEditor>
    </>
  );
};

export default DefaultButtonLarge;
